var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dy-main-container app-container app-container-full" },
    [
      !_vm.hideLeftAside
        ? [
            _c(
              "div",
              {
                staticClass: "dy-main-container-left",
                style: { width: _vm.dividerOption.leftAsideWidth },
              },
              [_vm._t("left")],
              2
            ),
            _vm._v(" "),
            _c(
              "DyDragDivider",
              _vm._b(
                {
                  attrs: {
                    "left-aside-width": _vm.dividerOption.leftAsideWidth,
                  },
                  on: { change: _vm.leftAsideWidthChange },
                },
                "DyDragDivider",
                _vm.$props.dividerOption,
                false
              )
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dy-main-container-right" },
        [
          !_vm.hideTopMenu
            ? [_c("div", { staticClass: "top-menu" }, [_vm._t("topMenu")], 2)]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "right-container" }, [
            _c("div", { staticClass: "right-content" }, [_vm._t("right")], 2),
          ]),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }